import AbstractService from '../abstract';
import ProfilesClass from './profileClass';

export const identifier = 'profiles';

export default class ProfileService extends AbstractService<ProfilesClass> {
    constructor() {
        super(identifier, ProfilesClass);
    }
}
